module.exports = __webpack_public_path__ + "static/media/img1-en-mobile.527d442b.png";